<template>
	<div>
		<b-row no-gutters>
			<b-col>
				<div class="py-5" style="background:#F1F1F1">
					<b-container class="container-project">
						<span style="padding:11px 7px 0px 7px;background:#c50f2A"></span>
						<span class="text-left show-apartment-title mt-4 h2 ml-2" v-if="apartment.asset_type">Datos del {{apartment.asset_type.split("_").join(" ").toLowerCase()}}</span>
						<b-row>
							<b-col cols="12" xl="6" class="w-100 py-3" order="1" order-xl="0">
								<div @click="showPhoto" v-if="photos">
									<b-carousel class="apartment-images my-4" v-model="carouselPosition"  v-if="photos.length > 0" :style="{ textShadow: '0px 0px 2px #000', minHeight: '100px' }" fade controls>
										<b-carousel-slide v-for="(photo, key ) in photos" :key="key" v-bind:style=" { background: 'url('+photo.image_url+')', backgroundSize: 'cover', backgroundPosition: 'center', width: '100%' }"></b-carousel-slide>
									</b-carousel>
									<b-modal id="modal-photo" size="xl" :interval="0" centered hide-header body-bg-variant="transparent" content-class="border-0 bg-transparent" hide-footer>
										<b-carousel v-model="setedPhoto" fade controls>
											<b-carousel-slide v-for="(photo, key ) in photos" :img-src="photo.image_url" :key="key"></b-carousel-slide>
										</b-carousel>
									</b-modal>
								</div>
								<div class="text-right small text-dark">
									<i>*Presiona en las fotos para verlas completas</i>
								</div>
							</b-col>
							<b-col cols="12" xl="6" class="my-auto pt-3 pt-xl-0" order="0" order-xl="1">
								<h2 class="bolder">{{apartment.project_name}} - {{apartment.number}}</h2>
								<p class="address-apartment">Dirección: {{apartment.project_address}}</p>
								<hr>
								<p class="text-secondary">Estado de la obra:</p>
								<div style="background:white;padding:5px 5px;border-radius:25px">
									<b-progress v-if="apartment.progress >= 0" :max="100" class="rounded-pill apartment-progress" style="background:white">
										<div class="progress-text" :style="{ position: 'absolute' }" style="left:45%;">
											<h5 class="mt-0 d-none d-lg-block"><b-badge pill variant="transparent">{{apartment.progress}}%</b-badge></h5>
											<b-badge class="d-lg-none mt-2" pill variant="transparent">{{apartment.progress}}%</b-badge>
										</div>
									<b-progress-bar variant="argenta" :value="apartment.progress" ></b-progress-bar>
									</b-progress>
								</div>
								<b-row class="pt-5 mt-xl-0">
									<b-col cols="12" xl="6" class="my-2">
										<div class="d-flex align-items-center mr-2">
											<div class="symbol symbol-45 symbol-light-gold mr-4 flex-shrink-0">
												<div class="symbol-label">
													<span class="svg-icon svg-icon-lg svg-icon-info">
														<font-awesome-icon :icon="['fal', 'bed']" size="lg" />
													</span>
												</div>
											</div>
											<div>
												<div class="h4 text-dark-75 font-weight-bolder mb-0">{{apartment.bedrooms}}</div>
												<div class="font-size-sm text-muted font-weight-bold">Dormitorio{{ apartment.bedrooms > 1 ? "s" : "" }}</div>
											</div>
										</div>
									</b-col>
									<b-col cols="12" xl="6" class="my-2">
										<div class="d-flex align-items-center mr-2">
											<div class="symbol symbol-45 symbol-light-gold mr-4 flex-shrink-0">
												<div class="symbol-label">
													<span class="svg-icon svg-icon-lg svg-icon-info">
														<font-awesome-icon :icon="['fal', 'bath']" size="lg" />
													</span>
												</div>
											</div>
											<div>
												<div class="h4 text-dark-75 font-weight-bolder mb-0">{{apartment.bathrooms}}</div>
												<div class="font-size-sm text-muted font-weight-bold">Baño{{ apartment.bathrooms > 1 ? "s" : "" }}</div>
											</div>
										</div>
									</b-col>
									<b-col cols="6" xl="6" v-if="apartment.parking_lots" class="my-2">
										<div class="d-flex align-items-center mr-2">
											<div class="symbol symbol-45 symbol-light-gold mr-4 flex-shrink-0">
												<div class="symbol-label">
													<span class="svg-icon svg-icon-lg svg-icon-info">
														<font-awesome-icon :icon="['fal', 'car-garage']" size="lg" />
													</span>
												</div>
											</div>
											<div>
												<div class="h4 text-dark-75 font-weight-bolder mb-0">{{apartment.parking_lots}} <small>({{apartment.parking_lots_data}})</small></div>
												<div class="font-size-sm text-muted font-weight-bold">Estacionamiento{{ apartment.parking_lots > 1 ? "s" : "" }}</div>
											</div>
										</div>
									</b-col>
									<b-col cols="12" xl="6" v-if="apartment.cellars" class="my-2">
										<div class="d-flex align-items-center mr-2">
											<div class="symbol symbol-45 symbol-light-gold mr-4 flex-shrink-0">
												<div class="symbol-label">
													<span class="svg-icon svg-icon-lg svg-icon-info">
														<font-awesome-icon :icon="['fal', 'warehouse-alt']" size="lg" />
													</span>
												</div>
											</div>
											<div>
												<div class="h4 text-dark-75 font-weight-bolder mb-0">{{apartment.cellars}} <small>({{apartment.cellars_data}})</small></div>
												<div class="font-size-sm text-muted font-weight-bold">Bodega{{ apartment.cellars > 1 ? "s" : "" }}</div>
											</div>
										</div>
									</b-col>
							</b-row>
							</b-col>
						</b-row>
					</b-container>
				</div>
				<b-container class="container-project">
					<div class="pt-5 pb-xl-0">
						<span style="padding:11px 7px 0px 7px;background:#c50f2A"></span>
						<span class="text-left show-apartment-title mt-4 h2 ml-2">Datos del proyecto</span>
					</div>
					<b-row class="mt-5">
						<b-col cols="12" xl="6" class="pt-3 pt-xl-0">
							<b-table-simple v-if="features.length > 0" borderless class="mt-2">
								<b-tr v-for="(feature, key ) in features" :key="key">
									<b-td width="1%" class="align-middle text-left h5">
										<font-awesome-icon :icon="['fal', setIcon(feature)]" size="2x" class="text-customer" />
									</b-td>
									<b-td class="h5">
										{{feature.DESCRIPCION}}
									</b-td>
								</b-tr>
							</b-table-simple>
						</b-col>
						<b-col cols="12" xl="6">
							<div v-if="apartment.project_photo" class="project-main-img" v-bind:style="{ backgroundImage: 'url(' + apartment.project_photo + ')' }" style="width:100%;">
							</div>
							
						</b-col>
					</b-row>
				</b-container>
			</b-col>
		</b-row>
	</div>
</template>
<script>
export default {
	name: "showApartment",
	props: {
		asset_id: null
	},
	data() {
		return {
			apartment: {},
			domain: process.env.VUE_APP_CUSTOMER_DOMAIN,
			photos: [],
			features: [],
			selectedApartment: null,
			tab_index: null,
			carouselPosition: 0,
			setedPhoto: 0,
		}
	},
	mounted() {
		this.setApartment();
	},
	methods: {
		setApartment() {
			this.apartment = this.$store.getters.getApartmentById(parseInt(this.asset_id));
			this.setPhotos();
		},
		setPhotos() {
			let self = this;
			this.axios.get("projects/"+this.apartment.project_id+"/get_features", {rut: self.rut}).then(result => {
				self.features = result.data.features;
				self.photos = result.data.images.filter(image => image.ACTIVO);
			}).catch(error => {
				console.log(error)
				self.features = []
			});
		},
		setIcon(feature){
			switch(feature.CATEGORIA){
				case "Areas Verdes":
					return "leaf";
				case "Areas comunes":
					return "dumbbell";
				case "Infraestructura":
					return "building";
				case "Característica departamento":
					return "door-closed";
				case "Espacios Utiles":
					return "garage-car";
				case "Plusvalía":
					return "chart-line";
				default:
					return "building";
			}
			//falLeaf, falDumbbell, falDoorClosed, falChartLine, falGarageCar
		},
		showPhoto(){
			this.setedPhoto = this.carouselPosition;
			this.$root.$emit('bv::show::modal', 'modal-photo')
		},
	},
	watch:{
		asset_id: {
			handler: function() {
				this.selected_tab = 0;
			}
		}
	}
};
</script>
<style>
.attribute-title{
	color:#888888!important;
}
.address-apartment{
	color:#3F3F3F!important
}
.show-apartment-title{
	font-weight: 850!important;
}
.arrow-bottom:before {
	content: "";
	width: 0px;
	height: 0px;
	position: absolute;
	border-right: 10px solid transparent;
	border-left: 10px solid transparent;
	border-bottom: 10px solid transparent;
	top: 100%;
	left: 50%;
}

.arrow-bottom:after {
	content: "";
	width: 0px;
	height: 0px;
	position: absolute;
	border-right: 10px solid transparent;
	border-left: 10px solid transparent;
	border-bottom: 10px solid transparent;
	border-top: 10px solid #6D6E71;
	top: 100%;
	left: 50%;
}
.project-main-img{
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	height:520px
}
.row-attribute{
	padding: 0px 45px;
}
.div-attribute{
	background:#F3F3F3;padding:30px 0px;margin-bottom:20px
}
.apartment-name{
	padding:50px 20px;
}
.attribute{
	font-size:27px;
	color:#888888!important;
}
@media (max-width: 1600px){
	.row-attribute{
		padding: 0px 30px;
	}
	.div-attribute{
		background:#F3F3F3;padding:30px 0px;margin-bottom:33px
	}
	.project-main-img{
		height:450px;
	}
	.apartment-name{
		padding:25px 20px;
	}
	.attribute{
		font-size:23px;
		color:#888888!important;
	}
	.div-attribute{
		background:#F3F3F3;padding:10px 0px;margin-bottom:20px
	}
	.attribute-title{
		color:#888888!important;
		font-size:13px
	}
}
</style> 